import type { CSSProperties, ReactNode } from 'react';
import { FIELD_LIST_EDITOR_INSET_PX } from '@/common/domain/fieldListSpacing';

/**
 * Editor-preview chrome only (LLAMS-610 Part 7, the ~35px read-only↔editing jump).
 * The 8px section frame and 4px element frame stay mounted with or without
 * `EditableDocumentContext`, so selecting a field does not shift the canvas.
 * Export mode does not render these frames — that document uses the pre-373a9a4
 * PDF metrics instead. `SelectableElement` decorates inside the reserved space
 * (outline via `boxShadow`, never `border`).
 */
const SECTION_INSET_PX = FIELD_LIST_EDITOR_INSET_PX.sectionPaddingY;
const ELEMENT_INSET_PX = FIELD_LIST_EDITOR_INSET_PX.elementPaddingY;

export function SectionInsetFrame({ children, testId }: { children: ReactNode; testId?: string }) {
  const style: CSSProperties = { paddingTop: SECTION_INSET_PX, paddingBottom: SECTION_INSET_PX };
  return (
    <div style={style} data-frame="columns-section" data-testid={testId}>
      {children}
    </div>
  );
}

export function ElementInsetFrame({ children, testId }: { children: ReactNode; testId?: string }) {
  const style: CSSProperties = { paddingTop: ELEMENT_INSET_PX, paddingBottom: ELEMENT_INSET_PX, position: 'relative' };
  return (
    <div style={style} data-frame="selectable-element" data-testid={testId}>
      {children}
    </div>
  );
}

export const EDITOR_INSET_PX = { section: SECTION_INSET_PX, element: ELEMENT_INSET_PX };
